<template>
  <section class="form-list">
    <el-form
      ref="form"
      :rules="rules"
      :model="administrator"
      label-position="right"
      label-width="130px"
      class="form"
    >
      <el-form-item label="用户名" prop="username">
        <el-input
          v-model="administrator.username"
          placeholder="请输入登录用户名"
          minlength="3"
          maxlength="17"
          show-word-limit
          clearable
        />
      </el-form-item>
      <el-form-item label="昵称" prop="nickname">
        <el-input
          v-model="administrator.nickname"
          placeholder="请输入昵称"
          maxlength="14"
          show-word-limit
          clearable
        />
      </el-form-item>
      <v-input-administrator-phone v-model="administrator.phone"/>
      <el-form-item label="企业微信号">
        <el-input
          v-model="administrator.we_chat"
          placeholder="请输入企业微信号"
          minlength="2"
          maxlength="32"
          show-word-limit
          clearable
        />
      </el-form-item>
      <v-image-upload
        v-model="administrator.avatar"
        label="头像"
        prefix="administrator"
        ratio="1:1"
        prop-name="selfie"
      />

<!--      <el-form-item label="2021学生祝福语">
        <el-input
          type="textarea"
          :autosize="{ minRows: 4 }"
          placeholder="请输入2021年学生想对管理员说的祝福语"
          v-model="administrator.blessing"
          maxlength="2000"
          show-word-limit
        />
      </el-form-item>-->

      <el-form-item>
        <el-button
          type="primary"
          :loading="isSaving"
          @click="handleSubmit"
        >
          保存修改
        </el-button>
        <el-button @click="RouteConfig.administratorList.back">取消</el-button>
      </el-form-item>
    </el-form>
  </section>
</template>

<script>
import RouteConfig from '@/router/config';
import { show, update } from '@/api/administrator';

export default {
  name: RouteConfig.administratorEdit.name,
  data: () => ({
    RouteConfig,
    isSaving: false,
    administrator: {
      username: '',
      phone: '',
      nickname: '',
      avatar: '',
      we_chat: '',
      update_time: 0,
      blessing: '',
    },
    rules: {
      username: [{ required: true, message: '请输入登录用户名', trigger: 'change' }],
      nickname: [{ required: true, message: '请输入昵称', trigger: 'change' }],
      avatar: [{ required: true, message: '请上传真人自拍', trigger: 'change' }],
    },
  }),
  computed: {
    id() {
      return +this.$route.params.id || 0;
    },
  },
  beforeMount() {
    this.show();
  },
  methods: {
    handleSubmit() {
      if (this.isSaving) return;

      this.$refs.form.validate(async (isSuccess) => {
        if (!isSuccess) return;

        const postData = { ...this.administrator };
        this.isSaving = true;
        const { isError } = await update(this.id, postData);
        this.isSaving = false;
        if (isError) return;

        RouteConfig.administratorList.back();
      });
    },
    async show() {
      const { isError, data } = await show(this.id);
      if (isError) return;

      const { administrator } = this;
      Object.keys(data).forEach(key => {
        if (key in administrator) administrator[key] = data[key];
      });
    },
  },
};
</script>
